import React,{useState} from 'react'
import styles from './Searchblog.module.css';
import searchone from '../../../Assets/Svg/icons8-search.svg'
const Searchblog = () => {
    const [visible, setVisible] = useState(true);
    const serachdisplay = () => {
        setVisible(false)
    }
    // window.addEventListener("click", function () {
    //     if (visible) {
           
    //         setVisible(false)
    //     } else {
    //         setVisible(true)
    //     }
      
    // })
    return (

        <div onClick={serachdisplay} className={styles.searchblog}>
            {visible && <div  className={styles.searchblog_icon}>
                <img src={searchone} alt="search" />
                {/* <i className="fa fa-search" aria-hidden="true"></i> */}
            </div>}
            <div className={styles.input}>
                <input type="text" placeholder="Search Hashnode" />
            </div>
            {visible && <div className={styles.btn}>/</div>}
        </div>
    )
}

export default Searchblog
